module.exports = __webpack_public_path__ + "static/img_9348-33e911ef2db7983f36d3abbe3f8735c4.webp";